import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Select, Spin } from "antd";
import React, { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import CreateOrganizationLevelApi from "../../../api/org-levels/CreateOrganizationLevelApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";
import ColorPicker from "../../sub/ColorPicker";

const { Option } = Select;

function AddOrgLevelModal(props) {
  const [submit, setSubmit] = useState(false);
  const [color, setColor] = useState("#03a9f4");
  const positionState = useSelector((state) => state.positionState.value);

  useEffect(() => {
    chooseAutoColor();
  }, [props.visible]);

  function chooseAutoColor() {
    let colors = [];
    props.levels?.forEach((level) => {
      colors.push(level?.color);
    });
    let initialColors = [
      "#f44336",
      "#e91e63",
      "#9c27b0",
      "#673ab7",
      "#3f51b5",
      "#2196f3",
      "#03a9f4",
      "#00bcd4",
      "#009688",
      "#4caf50",
      "#8bc34a",
      "#cddc39",
      "#ffeb3b",
      "#ffc107",
      "#ff9800",
      "#ff5722",
      "#795548",
      "#607d8b",
    ];
    let newColors = initialColors.filter(
      (element) => !colors.includes(element)
    );
    setColor(newColors[0]);
  }

  function handleCancel() {
    setColor("#03a9f4");
    setSubmit(false);
    props.handleCancel();
  }

  async function onFinish(value) {
    setSubmit(true);
    const apiResponse = await CreateOrganizationLevelApi(
      value.levelName,
      color,
      value.order,
      positionState?.id
    );

    if (apiResponse.statusCode) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.message === "success") {
      openNotificationSuccess("bottomRight", "Level added successfully");
      props.handleOk(apiResponse.level);
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't add level. Try again later."
      );
    }
    handleCancel();
  }

  function getOrders() {
    let output = [];

    props.levels?.forEach((level) => {
      output.push(
        <Option key={level.order + 1} value={level.order + 1}>
          {level.order + 1}
        </Option>
      );
    });

    return output;
  }

  return (
    <Modal
      title="Add organizational level"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="addOrgLevel"
        onFinish={onFinish}
        layout="vertical"
        requiredMark={false}
        autoComplete="off"
        initialValues={{
          order: props.order || props.levels?.length + 1 || 2,
          color: color,
        }}
      >
        <Form.Item label="Order*" name="order">
          <Select disabled={props.order === 1} placeholder="Select order">
            {getOrders()}
          </Select>
        </Form.Item>

        <Form.Item
          label="Level name*"
          extra="Give name in singular form"
          name="levelName"
          rules={[
            {
              required: true,
              message: "Please enter level name!",
            },
          ]}
        >
          <Input placeholder="Level name" />
        </Form.Item>

        <Form.Item label="Color*" name="color">
          <div className="w-20 h-8">
            <ColorPicker color={color} onChange={(value) => setColor(value)} />
          </div>
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={() => handleCancel()}>
              Cancel
            </Button>
            <Button
              className="btn w-28"
              type="primary"
              htmlType={submit && "submit"}
              disabled={submit}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Add"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default AddOrgLevelModal;
